import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import React from "react";
import {
  getLabel,
  getLabelTag,
  getLabelTagInput,
  getLabelTagYesNO,
} from "../constructTextFromValues";
import {
  nutritionalRatingOptions,
  nutritionalRiskType,
} from "../../Options/clinicalEvaluationOptions";
import clinicalEvaluationIcon from "../../../../assets/doctorIcons/clinicalEvaluation.svg";

const NutritionistClinicalEvaluationSummary = ({ formData }) => {
  const constructClinicalEvaulationSummaryItems = () => {
    const clinicalEvaluationSummaryItems = [];
    const pushClinicalEvaluationItem = (key, label, children) => {
      clinicalEvaluationSummaryItems.push({ key, label, children });
    };
    const evaluation = formData?.clinical_evaluation || {};
    if (evaluation?.bmi?.feet || evaluation?.bmi?.weight) {
      pushClinicalEvaluationItem(
        "1",
        "Anthopometric Data",
        <>
          {getLabelTagInput("BMI", evaluation?.bmi?.bmi_value, "kg/m2")}
          {getLabelTagInput("Interpretation", evaluation?.bmi?.interpretation)}
          {getLabelTagInput(
            "Height",
            getLabel(
              `${evaluation?.bmi?.height_feet}ft ${evaluation?.bmi?.height_inches}in`
            )
          )}
          {getLabelTagInput("Height(cm)", evaluation?.bmi?.height, "cm")}
          {getLabelTagInput("Ideal weight", evaluation?.bmi?.ibw, "kgs")}
          {getLabelTagInput("Actual Weight", evaluation?.bmi?.weight, "kgs")}
        </>
      );
    }
    if (
      evaluation?.blood_investigations?.hemoglobin ||
      evaluation?.blood_investigations?.rbs ||
      evaluation?.blood_investigations?.albumin ||
      evaluation?.blood_investigations?.total_proteins ||
      evaluation?.blood_investigations?.urea ||
      evaluation?.blood_investigations?.creatinine ||
      evaluation?.blood_investigations?.sodium ||
      evaluation?.blood_investigations?.potassium ||
      evaluation?.blood_investigations?.chlorine
    ) {
      pushClinicalEvaluationItem(
        "3",
        "Blood Investigations",
        <>
          {getLabelTagInput("Hb", evaluation?.blood_investigations?.hemoglobin)}
          {getLabelTagInput("RBS", evaluation?.blood_investigations?.rbs)}
          {getLabelTagInput(
            "Albumin",
            evaluation?.blood_investigations?.albumin
          )}
          {getLabelTagInput(
            "Total Proteins",
            evaluation?.blood_investigations?.total_proteins
          )}
          {getLabelTagInput("Urea", evaluation?.blood_investigations?.urea)}
          {getLabelTagInput(
            "Sr. Creatinine",
            evaluation?.blood_investigations?.creatinine
          )}
          {getLabelTagInput("Na+", evaluation?.blood_investigations?.sodium)}
          {getLabelTagInput("K+", evaluation?.blood_investigations?.potassium)}
          {getLabelTagInput("Cl-", evaluation?.blood_investigations?.chlorine)}
        </>
      );
    }
    if (evaluation?.nutritional_screening) {
      pushClinicalEvaluationItem(
        "4",
        "Nutritional Screening",
        getLabelTag(nutritionalRatingOptions, evaluation?.nutritional_screening)
      );
    }
    if (evaluation?.nutritional_risk_details?.risk) {
      pushClinicalEvaluationItem(
        "5",
        "Nutritional Risk",
        <>
          {getLabelTagYesNO(evaluation?.nutritional_risk_details?.risk)}
          {getLabelTag(
            nutritionalRiskType,
            evaluation?.nutritional_risk_details?.risk_type
          )}
          {getLabelTagInput(
            "Details",
            evaluation?.nutritional_risk_details?.risk_description
          )}
        </>
      );
    }
    return clinicalEvaluationSummaryItems;
  };
  const clinicalEvaluationSummaryItems =
    constructClinicalEvaulationSummaryItems();
  return (
    <SummaryWrapper
      items={clinicalEvaluationSummaryItems}
      title={
        <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
          <Space>
            <Image src={clinicalEvaluationIcon} width={18} preview={false} />
            <span style={{ fontSize: "16px", fontWeight: "normal" }}>
              Clinical Evaluation
            </span>
          </Space>
        </span>
      }
    />
  );
};

export default NutritionistClinicalEvaluationSummary;
